class ShowTip {
  init() {
    this.initShowTip();
  }
  initShowTip() {
    const label = document.querySelector('#tip-label');
    const button = document.querySelector('#tip-button');

    if (button && label) {
      button.addEventListener('click', () => {
        label.innerHTML = button.dataset.tip;
      });
    }
  }
}

export default new ShowTip();
